export const canDashboardChartDrillOrders = (snapshot, _chartBundle) => Boolean(snapshot);

/** 已保存图表全屏：钻取不可用时的说明文案 */
export const resolveSavedChartDrillDisabledReason = (snapshot, chartBundle, { ordersLoading = false } = {}) => {
	if (!snapshot || !chartBundle) return null;
	if (ordersLoading) return null;
	const ordersCount = chartBundle.orders?.length ?? 0;
	if (!ordersCount) {
		return '当前图表暂无订单数据，无法钻取';
	}
	return null;
};

/** 钻取已选中但筛选结果为空时的说明文案 */
export const resolveDashboardChartDrillEmptyMessage = (drill) => {
	if (!drill) return null;
	return drill.label ? `「${drill.label}」下暂无匹配订单` : '当前钻取条件下暂无匹配订单';
};

export default canDashboardChartDrillOrders;
